// extracted by mini-css-extract-plugin
var _1 = "WidgetContentFilesDownloadButton-moduleWidgetContentFilesDownloadButton__vsznU";
export { _1 as "WidgetContentFilesDownloadButton" }
